import apollonia from "../assets/images/wines/Apollonia Verdicchio dei Castelli di Jesi DOP Wine of Marche.png";
import campodicuori from "../assets/images/wines/Campo di Cuori Vino Bianco Spumante di qualita Wine of Marche.png";
import contatto from "../assets/images/wines/Contatto Verdicchio dei Castelli di Jesi DOP Wine of Marche.png";
import extrabrutrose from "../assets/images/wines/Extra Brut Rose Marche IGP Rosato Wine of Marche.png";
import flora from "../assets/images/wines/Flora Marche Bianco IGP Wine of Marche.png";
import isola from "../assets/images/wines/Isola Verdicchio dei Castelli di Jesi DOP  Wine of Marche.png";
import opere from "../assets/images/wines/Opere Verdicchio dei Castelli di Jesi DOP  Wine of Marche.png";
import suono from "../assets/images/wines/Suono Rosso Piceno DOP Wine of Marche.png";
import urbano from "../assets/images/wines/Urbano Marche Rosso IGP Wine of Marche.png";
import lacrima from "../assets/images/wines/Lacrima Lacrima di Morro d'Alba DOP Wine of Marche.png";
import millesimato from "../assets/images/wines/Millesimato Millesimato Valdobbiadene Prosecco Superiore DOCG Wine of Marche.png";

export const imagesOfWines = [
  {
    id: "isola",
    image: isola,
  },
  {
    id: "opere",
    image: opere,
  },
  {
    id: "flora",
    image: flora,
  },
  {
    id: "urbano",
    image: urbano,
  },
  {
    id: "suono",
    image: suono,
  },
  {
    id: "apollonia",
    image: apollonia,
  },
  {
    id: "contatto",
    image: contatto,
  },
  {
    id: "extrabrutrose",
    image: extrabrutrose,
  },
  {
    id: "campodicuori",
    image: campodicuori,
  },
  {
    id: "lacrima",
    image: lacrima,
  },
  {
    id: "millesimato",
    image: millesimato,
  },
];
